module.exports = __webpack_public_path__ + "static/media/face7.7af91f95.jpg";